class LastRouteService {
    private static _it_self: LastRouteService;
    private _history: string = null;

    static get _it() {
        if (! LastRouteService._it_self) LastRouteService._it_self = new LastRouteService();
        return LastRouteService._it_self;
    }

    setNew(val: string = null) {
        if ((/^[\s]*\/(login|logout|forgot\-password|set\-password|enter\/by)/i).exec(val)) {
            if ((/^[\s]*\/(logout|enter\/by)/i).exec(val)) this._history = null;
            return;
        } else this._history = val;
    }

    get lastUrl() {
        return this._history ? this._history : '/';
    }
}

export const LastUrl = LastRouteService._it;



// WEBPACK FOOTER //
// ./src/app/services/LastRouteService.ts